export default __webpack_public_path__ + "static/media/grace.6eb2f565.jpg";